export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/sv.lyaml"));
at({ "sv": { "public": { "sampleString": "Exempelstr\xE4ng" } } });
};